import { useClipboard } from '@calendly/clipboard';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CheckboxInput } from '@calendly/ui/components/checkbox-input';
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck';
import { IconCopy } from '@calendly/ui/components/glyphs/IconCopy';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import { ShareContext } from './context';
const flexContainerBlueCss = "fiuld8o";
const FlexContainerBlue = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexContainerBlueCss, props.className)} />;
});
const gridContainerCss = "gp8p2jj";
const GridContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(gridContainerCss, props.className)} />;
});
const labelCss = "l115kzzb";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const labelContainerCss = "lbja466";
const LabelContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelContainerCss, props.className)} />;
});
const passcodeContainerCss = "p78cfg1";
const PasscodeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(passcodeContainerCss, props.className)} />;
});
const passcodeSpanCss = "p106v2yx";
const PasscodeSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(passcodeSpanCss, props.className)} />;
});
const styledSnippetSpanCss = "s452pdv";
const StyledSnippetSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledSnippetSpanCss, props.className)} />;
});
const styledShareLinkSpanCss = "s9wi6oi";
const StyledShareLinkSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledShareLinkSpanCss, props.className)} />;
});
const CopyButton = ({
  passcode
}) => {
  const [Wrapper, ref, isCopied] = useClipboard(passcode || '');
  return <Wrapper>
      <BareButton ref={ref}>
        <FlexContainerBlue>
          {isCopied ? <UiIcon icon={IconCheck} size="small" title="" /> : <UiIcon icon={IconCopy} size="small" title="" />}
          <span>{isCopied ? 'Copied' : 'Copy'}</span>
        </FlexContainerBlue>
      </BareButton>
    </Wrapper>;
};
export const PasscodeCheckbox = ({
  isSnippet
}) => {
  const {
    share,
    togglePasscode
  } = useContext(ShareContext);
  const {
    accessLevel,
    passcode: videoPasscode
  } = share;
  const onChange = e => {
    e.preventDefault();
    togglePasscode();
  };
  return <GridContainer>
      <Label>
        <CheckboxInput checked={accessLevel === 'Passcode'} onChange={onChange} />
      </Label>

      <LabelContainer>
        {isSnippet ? <StyledSnippetSpan>Restrict access with a passcode</StyledSnippetSpan> : <StyledShareLinkSpan>Restrict access with a passcode</StyledShareLinkSpan>}
        <ProTip>
          {I18n.t('publisher.meeting_intelligence.share.passcode_protip')}
        </ProTip>
      </LabelContainer>

      {accessLevel === 'Passcode' && <PasscodeContainer>
          <PasscodeSpan>Passcode:</PasscodeSpan>
          <b>{videoPasscode}</b>
          <CopyButton passcode={videoPasscode} />
        </PasscodeContainer>}
    </GridContainer>;
};

require("./passcode_checkbox.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./passcode_checkbox.js");